module.exports = __webpack_public_path__ + "static/Gallery-6-757391b1fad2c2129b69e12ead8249ea.jpg";